<template>
    <status :attached="true"></status>
</template>

<script>

import Status from "./Status";
export default {
    components: {Status},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
